import { useState } from 'react';
import { Input } from '@hrms/ui';
import { SALARY_PIN_MAX_LENGTH } from '@hrms/shared';
import { PasswordToggle } from '../../routes/auth/AuthLayout.js';

/**
 * One salary PIN box: digits only, masked, never offered to a password manager or autofill (the PIN is
 * not the password, and a saved one would defeat the point of asking). The eye toggle lets the person
 * check what they typed, the same as the password fields.
 */
export function SalaryPinField({
  label,
  value,
  onChange,
  error,
  hint,
  autoFocus,
  disabled,
  name,
}: {
  label: string;
  value: string;
  onChange: (digits: string) => void;
  error?: string | null;
  hint?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  name: string;
}) {
  const [shown, setShown] = useState(false);
  return (
    <Input
      label={label}
      name={name}
      type={shown ? 'text' : 'password'}
      inputMode="numeric"
      autoComplete="off"
      pattern="[0-9]*"
      maxLength={SALARY_PIN_MAX_LENGTH}
      placeholder="••••"
      suffix={<PasswordToggle shown={shown} onToggle={() => setShown((v) => !v)} />}
      className="pr-11 text-center font-mono text-lg tracking-[0.5em]"
      value={value}
      error={error ?? undefined}
      hint={hint}
      autoFocus={autoFocus}
      disabled={disabled}
      onChange={(event) =>
        onChange(event.target.value.replace(/\D/g, '').slice(0, SALARY_PIN_MAX_LENGTH))
      }
    />
  );
}
